/**
 * records-page-steps.js
 */

import React from 'react';
import TourStep from '../tour-step';
import tourStepProps from '../tour-step-props';


export default [
  {
    target: "[data-testid='records-title']",
    title: "Introduction",
    ...tourStepProps,
    placementBeacon: "right",
    content: (
      <TourStep name='Records Page Tour'>
          This tour provides an overview of the <strong>Records</strong> page.
          From here you can view and manage all of your records in PACKTRACK.
      </TourStep>
    ),
  },
  {
    target: "[data-testid='records-calendar']",
    title: "Calendar",
    ...tourStepProps,
    content: (
      <TourStep name='Records Page Tour'>
        All of your training and deployment activities will show in the calendar.
        Training activities display as circles while deployments use stars.
        Scroll through the months using the arrows in the upper left and right.
        Click on a date to only show records that happened on that date.
      </TourStep>
    ),
  },
  {
    target: "[data-testid='records-list']",
    title: "Records List",
    ...tourStepProps,
    content: (
      <TourStep name='Records Page Tour'>
        This is where your training and deployment records will appear (you may not have any yet).
        Click the button with 3 horizontal dots on the far right to open the menu for that record.
        Click anywhere else on a record row to open the <strong>Record Editor</strong> where you can make changes to your records.
      </TourStep>
    ),
  },
  {
    target: "[data-testid='add-record-button']",
    title: "Adding New Records",
    ...tourStepProps,
    content: (
      <TourStep name='Records Page Tour'>
        Use this button to add new Training, Class and Deployment records.
        This will open the <strong>Record Editor</strong> where you create and edit your records.
      </TourStep>
    ),
  }
];
